var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12695 6.89062V0.917092C6.89831 1.03459 6.68711 1.1877 6.50195 1.37286L1.60919 6.26563C1.42403 6.45078 1.27092 6.66198 1.15342 6.89062H7.12695ZM9.62695 6.89062V0.640625H18.377C19.7577 0.640625 20.877 1.75991 20.877 3.14062V23.1406C20.877 24.5213 19.7577 25.6406 18.377 25.6406H3.37695C1.99624 25.6406 0.876953 24.5213 0.876953 23.1406V16.8906H10.3592L9.99307 17.2567C9.50491 17.7449 9.50491 18.5364 9.99307 19.0245C10.4812 19.5127 11.2727 19.5127 11.7608 19.0245L14.2608 16.5245C14.749 16.0364 14.749 15.2449 14.2608 14.7567L11.7608 12.2567C11.2727 11.7686 10.4812 11.7686 9.99307 12.2567C9.50491 12.7449 9.50491 13.5364 9.99307 14.0245L10.3592 14.3906H0.876953V9.39062H7.12695C8.50766 9.39062 9.62695 8.27134 9.62695 6.89062Z",
    fill: "#58267F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.330d0ac3aceae23127a5f123410adc22.svg";
export { ForwardRef as ReactComponent };